module.exports = __webpack_public_path__ + "img/item3btn1active.7d5abeb1.png";